module.exports = __webpack_public_path__ + "static/img/12.be24803.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/zh/12.png
// module id = w/nT
// module chunks = 0